// Math utilty functions

export const mathMin = Math.min

export const mathMax = Math.max

export const mathCeil = Math.ceil

export const mathPow = Math.pow

export const mathRound = Math.round
